<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2 v-if="this.id">Edit</h2> 
                <h2 v-else>Create</h2>
                <h4>Retailer</h4>
            </div>
            <div class="col-md-6 text-right" v-if="riskRating != ''">
                <h4>Risk Rating: </h4>
                <h4>{{ riskRating }}</h4>
            </div>
        </div> 
        <div class="row mt-4">
            <form novalidate="novalidate" @submit.prevent="submit"  class="col col-md-12 border-top border-bottom py-4"> 
                <!--  needs-validation -->
                <div class="form-group row">
                    <div class="col-md-3 mb-2">
                        <select class="custom-select " :class="{'is-invalid':retailerTypeHasErrors}" required="required" name="retailerType" id="retailerType" v-model="retailerType">
                            <option value="">Select Retailer Type</option>
                            <option v-for="type in types" :key="type.id" :value="type.id">
                                {{ type.name }}
                            </option>
                        </select>
                        <form-error name="retailer_type_id" :errors="errors"></form-error>
                    </div>
                    <div class="col-md-3 mb-2">
                        <select class="custom-select " :class="{'is-invalid':forceHasErrors}" required="required" name="force" id="force" v-model="force">
                            <option value="">Select Force</option>
                            <option v-for="force in forces" :key="force.id" :value="force.id">
                                {{ force.name }}
                            </option>
                        </select>
                        <form-error name="force_id" :errors="errors"></form-error>
                    </div>
                    <div class="col-md-3 mb-2">
                        <select class="custom-select " id="lpa" name="lpa" required="required" v-model="lpa">
                            <option value="">Select LPA</option>
                            <option v-for="lpa in lpas" :key="lpa.id" :value="lpa.id">
                                {{ lpa.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3 mb-2">
                        <select class="custom-select " :class="{'is-invalid': neighbourhoodHasErrors}" id="neighbourhood" name="neighbourhood" required="required" v-model="neighbourhood">
                            <option value="">Select Neighbourhood</option>
                            <option v-for="neighbourhood in neighbourhoods" :key="neighbourhood.id" :value="neighbourhood.id">
                                {{ neighbourhood.name }}
                            </option>
                        </select>
                        <form-error name="neighbourhood_id" :errors="errors"></form-error>
                    </div>
                </div> 
                <hr>
                <div class="form-group row">
                    <div class="col-md-6">
                        <h4>Retailer Details</h4>
                        <div class="row form-group mt-3">
                            <div class="col-md-2">
                                <label for="retailerName">Name</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerName" id="retailerName" class="form-control " :class="{'is-invalid': retailerNameHasErrors}" v-model="name">
                                <form-error name="retailer_name" :errors="errors"></form-error>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="postcodeSearch">Search Postcode</label>
                            </div>
                            <div class="col-md-4 mb-2">
                                <input type="text" name="postcodeSearch" id="postcodeSearch" class="form-control"  v-model="postcodeSearch">
                            </div>
                            <div class="col md-3 mb-2">
                                <button type="button" class="btn btn-primary" v-on:click="findAddresses">
                                    Find Address
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                </button>
                            </div>
                        </div>
                        <div class="row form-group" v-if="this.addresses.length != 0">
                            <div class="col-md-8 offset-md-2">
                                <select class="custom-select " id="addresses" name="addresses" v-model="selectedAddress">
                                    <option value="">Please select</option>
                                    <option v-for="address in addresses" :key="address.id" :value="address.id">
                                        {{ address.l }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerStreet">Street</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerStreet" id="retailerStreet" class="form-control " :class="{'is-invalid': retailerStreetHasErrors}" v-model="street">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerTown">Town</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerTown" id="retailerTown" class="form-control " :class="{'is-invalid': retailerTownHasErrors}" v-model="town">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerCounty">County</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerCounty" id="retailerCounty" class="form-control " :class="{'is-invalid': retailerCountyHasErrors}" v-model="county">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerPostcode">Postcode</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerPostcode" id="retailerPostcode" class="form-control " :class="{'is-invalid': retailerPostcodeHasErrors}" v-model="postcode">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerLat">Latitude</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerLat" id="retailerLat" class="form-control" v-model="lat">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerLat">Longitude</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerLong" id="retailerLong" class="form-control" v-model="long">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerPhone">Phone No.</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerPhone" id="retailerPhone" class="form-control" v-model="phone">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="retailerEmail">Email</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="retailerEmail" id="retailerEmail" class="form-control " :class="{'is-invalid':retailerEmailHasErrors}" v-model="email">
                                <form-error name="retailer_email" :errors="errors"></form-error>
                            </div>
                        </div>
                        <div class="row form-group" v-if="this.retailerType == 4">
                            <div class="col-md-2">
                                <label for="mobileVehicleDesc">Vehile Description</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="mobileVehicleDesc" id="mobileVehicleDesc" class="form-control " v-model="vehileDescription">
                            </div>
                        </div>
                        <div class="row form-group" v-if="this.retailerType == 4">
                            <div class="col-md-2">
                                <label for="mobileVRM">VRM</label>
                            </div>
                            <div class="col-md-8">
                                <input type="text" name="mobileVRM" id="mobileVRM" class="form-control " :class="{'is-invalid':vrmHasErrors}" v-model="vrm">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>Opening Times</h4>
                        <div class="row mt-3">
                            <div class="col-md-3 col-6 offset-md-3">
                                <h5>Open</h5>
                            </div>
                            <div class="col-md-3 col-6">
                                <h5>Close</h5>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <label for="mondayOpen">Monday</label>
                            </div>
                            <div class="col-md-3 col-6 mb-2">
                                <input type="text" class="form-control" name="mondayOpen" id="mondayOpen" v-model="mondayOpen" v-if="mondayOpen == 'Closed'">
                                <flat-pickr
                                    v-else 
                                    class="form-control " :class="{'is-invalid':mondayOpenHasErrors}" 
                                    v-model="mondayOpen"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 col-6">
                                <input type="text" class="form-control" name="mondayClose" id="mondayClose" v-model="mondayClose" v-if="mondayClose == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':mondayCloseHasErrors}" 
                                    v-model="mondayClose"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 p-md-0">
                                <button v-on:click="closedOnDay('monday')" class="btn btn-link px-0" type="button" :disabled="loading">Closed</button>
                                <button v-on:click="setOpeningTimes" class="btn btn-link ml-3" type="button" :disabled="loading">Set All</button>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <label for="tuesdayOpen">Tuesday</label>
                            </div>
                            <div class="col-md-3 col-6 mb-2">
                                <input type="text" class="form-control" name="tuesdayOpen" id="tuesOpen" v-model="tuesdayOpen" v-if="tuesdayOpen == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':tuesdayOpenHasErrors}" 
                                    v-model="tuesdayOpen"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 col-6">
                                <input type="text" class="form-control" name="tuesdayClose" id="tuesdayClose" v-model="tuesdayClose" v-if="tuesdayClose == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':tuesdayCloseHasErrors}" 
                                    v-model="tuesdayClose"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 p-md-0">
                                <button v-on:click="closedOnDay('tuesday')" class="btn btn-link px-0" type="button" :disabled="loading">Closed</button>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <label for="wednesdayOpen">Wednesday</label>
                            </div>
                            <div class="col-md-3 col-6 mb-2">
                                <input type="text" class="form-control" name="wednesdayOpen" id="wednesdayOpen" v-model="wednesdayOpen" v-if="wednesdayOpen == 'Closed'">
                                <flat-pickr
                                    v-else 
                                    class="form-control " :class="{'is-invalid':wednesdayOpenHasErrors}" 
                                    v-model="wednesdayOpen"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 col-6">
                                <input type="text" class="form-control" name="wednesdayClose" id="wednesdayClose" v-model="wednesdayClose" v-if="wednesdayClose == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':wednesdayCloseHasErrors}" 
                                    v-model="wednesdayClose"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 p-md-0">
                                <button v-on:click="closedOnDay('wednesday')" class="btn btn-link px-0" type="button" :disabled="loading">Closed</button>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <label for="thursdayOpen">Thursday</label>
                            </div>
                            <div class="col-md-3 col-6 mb-2">
                                <input type="text" class="form-control" name="thursdayOpen" id="thursdayOpen" v-model="thursdayOpen" v-if="thursdayOpen == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':thursdayOpenHasErrors}" 
                                    v-model="thursdayOpen"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 col-6">
                                <input type="text" class="form-control" name="thursdayClose" id="thursdayClose" v-model="thursdayClose" v-if="thursdayClose == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':thursdayCloseHasErrors}" 
                                    v-model="thursdayClose"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 p-md-0">
                                <button v-on:click="closedOnDay('thursday')" class="btn btn-link px-0" type="button" :disabled="loading">Closed</button>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <label for="fridayOpen">Friday</label>
                            </div>
                            <div class="col-md-3 col-6 mb-2">
                                <input type="text" class="form-control" name="fridayOpen" id="fridayOpen" v-model="fridayOpen" v-if="fridayOpen == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':fridayOpenHasErrors}" 
                                    v-model="fridayOpen"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 col-6">
                                <input type="text" class="form-control" name="fridayClose" id="fridayClose" v-model="fridayClose" v-if="fridayClose == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':fridayCloseHasErrors}" 
                                    v-model="fridayClose"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 p-md-0">
                                <button v-on:click="closedOnDay('friday')" class="btn btn-link px-0" type="button" :disabled="loading">Closed</button>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <label for="saturdayOpen">Saturday</label>
                            </div>
                            <div class="col-md-3 col-6 mb-2">
                                <input type="text" class="form-control" name="saturdayOpen" id="saturdayOpen" v-model="saturdayOpen" v-if="saturdayOpen == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':saturdayOpenHasErrors}" 
                                    v-model="saturdayOpen"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 col-6">
                                <input type="text" class="form-control" name="saturdayClose" id="saturdayClose" v-model="saturdayClose" v-if="saturdayClose == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':saturdayCloseHasErrors}" 
                                    v-model="saturdayClose"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 p-md-0">
                                <button v-on:click="closedOnDay('saturday')" class="btn btn-link px-0" type="button" :disabled="loading">Closed</button>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <label for="sundayOpen">Sunday</label>
                            </div>
                            <div class="col-md-3 col-6 mb-2">
                                <input type="text" class="form-control" name="sundayOpen" id="sundayOpen" v-model="sundayOpen" v-if="sundayOpen == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':sundayOpenHasErrors}" 
                                    v-model="sundayOpen"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 col-6">
                                <input type="text" class="form-control" name="sundayClose" id="sundayClose" v-model="sundayClose" v-if="sundayClose == 'Closed'">
                                <flat-pickr 
                                    v-else
                                    class="form-control " :class="{'is-invalid':sundayCloseHasErrors}" 
                                    v-model="sundayClose"
                                    :config="timeConfig">
                                </flat-pickr>
                            </div>
                            <div class="col-md-3 p-md-0">
                                <button v-on:click="closedOnDay('sunday')" class="btn btn-link px-0" type="button" :disabled="loading">Closed</button>
                            </div>
                        </div>
                        <h4 class="mt-4">CCTV Coverage</h4>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <input class="mr-3" type="checkbox" name="cctvInternal" id="cctvInternal" v-model="CCTVInternal">
                                <label class="form-check-label" for="cctvInternal">Internal</label>
                            </div>
                            <div class="col-md-6">
                                <input class="mr-3" type="checkbox" name="cctvExternal" id="cctvExternal" v-model="CCTVExternal">
                                <label class="form-check-label" for="cctvExternal">External</label>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="cctvNote">Note</label>
                            </div>
                            <div class="col-md-7">
                                <textarea class="form-control" name="cctvNote" id="cctNote" cols="30" rows="2" v-model="CCTVNote"></textarea>
                            </div>
                        </div>
                        <h4 class="mt-4">Products/Services Bought</h4>
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label for="productCategories">Categories</label>
                            </div>
                            <div class="col-md-7">
                                <multiselect v-model="categories" :options="categoryOptions" label="name" track-by="id" :multiple="true" :hideSelected="true"></multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row form-group">
                    <div class="col-md-12">
                        <h4 class="mb-4">Risk Rating</h4>
                        <div class="row form-group mb-0" v-for="risk in this.risks" :key="risk.id">
                            <div class="col-md-4">
                                <label for="" class="font-weight-bold">{{ risk.text }}</label>
                            </div>
                            <div class="col-md-1">
                                <input type="checkbox" name="" id="" v-model="riskAnswers[risk.id].answer">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12" v-if="this.id">
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Edit</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                        <button v-if="this.closed_at != null" v-on:click="reopenRetailer" class="btn btn-primary ml-4">Reopen Retailer</button>
                        <button v-else v-on:click="closeRetailer" class="btn btn-primary ml-4">Close Retailer</button>
                    </div>
                    <div class="col-sm-12" v-else>
                        <button type="submit" class="btn btn-primary" >Create</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <button class="btn btn-link px-0" @click.prevent="back">Back to List</button>
                    </div>
                </div> 
            </form>
        </div>
    </div>
</template>

<script>
import store from "../../../store/index"
import FormError from "../../Util/FormError"
import RetailersService from "../../../services/RetailersService";
import PostcodeLookupService from "../../../services/PostcodeLookupService";
import CurrentUser from '../../../mixins/CurrentUser';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data: function () {
        return {
            loading: false,
            lpa: '',
            neighbourhood: '',
            force: store.state.currentUser.force_id,
            retailerType: '',
            name: '',
            postcodeSearch: '',
            street: '',
            town: '',
            county: '',
            postcode: '',
            lat: '',
            long: '',
            phone: '',
            email: '',
            mondayOpen: '',
            mondayClose: '',
            tuesdayOpen: '',
            tuesdayClose: '',
            wednesdayOpen: '',
            wednesdayClose: '',
            thursdayOpen: '',
            thursdayClose: '',
            fridayOpen: '',
            fridayClose: '',
            saturdayOpen: '',
            saturdayClose: '',
            sundayOpen: '',
            sundayClose: '',
            CCTVInternal: 0,
            CCTVExternal: 0,
            CCTVNote: '',
            categories: [],
            riskRating: '',
            vehileDescription: '',
            vrm: '',
            lastVisit: null,
            closed_at: null,
            riskAnswers: [],
            errors: {},
            retailer: null,
            skipRiskReset: false,
            pauseWatch: false,
            addresses: [],
            selectedAddress: '',
            timeConfig: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true
            }
        }
    },

    props: {
        id: {
            default: null,
        },
    },

    mixins: [CurrentUser],
    
    components: {
        Multiselect,
        FormError,
        flatPickr  
    },

    mounted() {
        this.pauseWatch = true;
        this.$store.dispatch('lpas/load');
        this.$store.dispatch('neighbourhoods/load');
        this.$store.dispatch('retailertypes/load');
        this.$store.dispatch('risks/load');
        this.$store.dispatch('productcategories/load');
        
        if (this.id) {
            this.load();
        }
    },

    watch: {
        id: function () {
            this.load();  
        },
        
        retailerType: function () {
            if(this.skipRiskReset) {
                this.skipRiskReset = false;
                return;
            }

            this.riskAnswers = [];
            let first = true;
            for (const risk of this.risks) {
                this.riskAnswers[risk.id] = {
                    risk_id: risk.id,
                    answer: first ? true : false
                };
                first = false;
            }
        },

        force: function () {
            if (this.pauseWatch) {
                return '';
            }
            this.lpa = '';
            this.neighbourhood = '';
        },
        lpa: function () {
            if (this.pauseWatch) {
                this.pauseWatch = false;
                return '';
            }
            this.neighbourhood = '';
        },

        selectedAddress: function () {
            if(this.selectedAddress === '') {
                this.street = this.town = this.county = this.postcode = '';
                return;
            }
            this.populateAddressFields(this.selectedAddress);
        }
    },

    methods: {

        closedOnDay: function (day) {
            let dayOpen = day + 'Open';
            let dayClose = day + 'Close';
            
            this[dayOpen] = 'Closed';
            this[dayClose] = 'Closed';
        },

        setOpeningTimes: function () {
            this.tuesdayOpen = this.wednesdayOpen = this.thursdayOpen = this.fridayOpen = this.saturdayOpen = this.sundayOpen = this.mondayOpen;
            this.tuesdayClose = this.wednesdayClose = this.thursdayClose = this.fridayClose = this.saturdayClose = this.sundayClose = this.mondayClose;
        },

        closeRetailer: function () {
            this.closed_at = Date();
            this.submit();
        },

        reopenRetailer: function () {
            this.closed_at = null;
            this.submit();
        },

        findAddresses: function () {
            this.addresses = [];
            if(this.postcodeSearch != '') {
                this.loading = true;
                PostcodeLookupService.addresses(this.postcodeSearch)
                    .then(({data}) => {
                        this.addresses = data;
                        this.postcodeSearch = '';
                        this.loading = false;
                    });
            }
        },

        populateAddressFields: function (addressId) {
            PostcodeLookupService.get(addressId)
                .then( ({data}) => {
                    this.street = data.data.street;
                    this.town = data.data.town;
                    this.county = data.data.county;
                    this.postcode = data.data.postcode;
                });
        },

        submit: function () {
            if (this.id === null) {
                RetailersService.store(this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            } else {
                RetailersService.update(this.id, this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            }
        },

        formData: function () {
            let answers = [];
            for (const answer of this.riskAnswers) {
                if(answer != undefined) {
                    answers.push(answer);
                }
            }

            return {
                retailer_type_id: this.retailerType,
                neighbourhood_id: this.neighbourhood,
                force_id: this.force,
                retailer_name: this.name,
                retailer_street: this.street,
                retailer_town: this.town,
                retailer_county: this.county,
                retailer_postcode: this.postcode,
                lat: this.lat,
                long: this.long,
                retailer_phone_number: this.phone,
                retailer_email: this.email,
                monday_open: this.mondayOpen,
                monday_close: this.mondayClose,
                tuesday_open: this.tuesdayOpen,
                tuesday_close: this.tuesdayClose,
                wednesday_open: this.wednesdayOpen,
                wednesday_close: this.wednesdayClose,
                thursday_open: this.thursdayOpen,
                thursday_close: this.thursdayClose,
                friday_open: this.fridayOpen,
                friday_close: this.fridayClose,
                saturday_open: this.saturdayOpen,
                saturday_close: this.saturdayClose,
                sunday_open: this.sundayOpen,
                sunday_close: this.sundayClose,
                cctv_internal: this.CCTVInternal,
                cctv_external: this.CCTVExternal,
                cctv_note: this.CCTVNote,
                product_categories: this.selectedCategories,
                mobile_vehicle_description: this.vehileDescription,
                mobile_vrm: this.vrm,
                closed_at: this.closed_at,
                risk_answers: answers
            };
        },

        success: function () {            
            window.flash((this.id ? 'Retailer Updated' : 'Retailer Created'));
            this.reset();
            this.$router.push({name: 'retailers.index'}).catch(()=>{});
        },

        failed: function (response) {
            this.errors = response.data.errors;
        },

        load: function () {
            this.loading = true;
            RetailersService.get(this.id)
                .then( ({data}) => {
                    this.retailer = data.data;
                    this.force = data.data.force_id;
                    this.lpa = data.data.lpa.id;
                    this.neighbourhood = data.data.neighbourhood.id;
                    this.retailerType = data.data.retailer_type_id;
                    this.name = data.data.retailer_name;
                    this.street = data.data.retailer_street;
                    this.town = data.data.retailer_town;
                    this.county = data.data.retailer_county;
                    this.postcode = data.data.retailer_postcode;
                    this.lat = data.data.lat;
                    this.long = data.data.long;
                    this.phone = data.data.retailer_phone_number;
                    this.email = data.data.retailer_email;
                    this.mondayOpen = data.data.monday_open;
                    this.mondayClose = data.data.monday_close;
                    this.tuesdayOpen = data.data.tuesday_open;
                    this.tuesdayClose = data.data.tuesday_close;
                    this.wednesdayOpen = data.data.wednesday_open;
                    this.wednesdayClose = data.data.wednesday_close;
                    this.thursdayOpen = data.data.thursday_open;
                    this.thursdayClose = data.data.thursday_close;
                    this.fridayOpen = data.data.friday_open;
                    this.fridayClose = data.data.friday_close;
                    this.saturdayOpen = data.data.saturday_open;
                    this.saturdayClose = data.data.saturday_close;
                    this.sundayOpen = data.data.sunday_open;
                    this.sundayClose = data.data.sunday_close;
                    this.CCTVInternal = data.data.cctv_internal;
                    this.CCTVExternal = data.data.cctv_external;
                    this.CCTVNote = data.data.cctv_note;
                    this.categories = this.formatProductCategories(data.data.product_categories);
                    this.riskRating = data.data.risk_rating;
                    this.lastVisit = data.data.last_visit;
                    this.signedUpToWDBC = data.data.last_visit != null ? data.data.last_visit.risk_sign_up_to_wdbc : '',
                    this.checksForSmartwater = data.data.last_visit != null ? data.data.last_visit.risk_checks_for_smartwater : '',
                    this.retrievableCCTV = data.data.last_visit != null ? data.data.last_visit.risk_has_retrievable_cctv : '',
                    this.idCheckingCompliant = data.data.last_visit != null ? data.data.last_visit.risk_id_checking_compliant : '',
                    this.keepsRecords = data.data.last_visit != null ? data.data.last_visit.risk_keeps_records : '',
                    this.signsDisplayed = data.data.last_visit != null ? data.data.last_visit.risk_signs_displayed : '',
                    this.propertyCheckingSystem = data.data.last_visit != null ? data.data.last_visit.risk_uses_property_checking_system : '',
                    this.unreportedStolenGoods = data.data.last_visit != null ? data.data.last_visit.risk_stolen_goods_in_last_month_not_reported_to_police : '',
                    this.riskAnswers = this.formatRiskAnswers(data.data.risk_answers);
                    this.vehileDescription = data.data.mobile_vehicle_description;
                    this.vrm = data.data.mobile_vrm,
                    this.closed_at = data.data.closed_at,
                    this.loading = false;
                    this.skipRiskReset = true;
                });
        },

        back: function () {
            this.$router.go(-1);
        },

        reset: function () {
            this.force = this.lpa = this.neighbourhood = this.name = this.postcodeSearch = this.street = this.town = this.county = this.postcode = this.lat = this.long = this.phone = this.email = this.cctvNote = this.vehileDescription = this.vrm = '';
            this.mondayOpen = this.mondayClose = this.tuesdayOpen = this.tuesdayClose = this.wednesdayOpen = this.wednesdayClose = this.thursdayOpen = this.thursdayClose = this.fridayOpen = this.fridayClose = this.saturdayOpen = this.saturdayClose = this.sundayOpen = this.sundayClose = '';
            this.categories = [];
            this.CCTVInternal = this.CCTVExternal = 0;
            this.errors = {};
        },

        hasError: function (key) {
            return (this.errors[key]);
        },

        formatRiskAnswers: function (riskAnswers) {
            let answers = [];

            for (const answer of riskAnswers) {
                answers[answer.risk_id] = answer;
            }
            return answers;
        },

        formatProductCategories: function (productCategories) {
            let categories = [];

            for (const cat of productCategories) {
                const category = this.categoryOptions.filter(category => category.id === cat.id);
                if(category.length == 1) {
                    categories.push(category[0]);
                }
            }
            return categories;
        }
    },

    computed: {
        forceHasErrors: function () { return this.hasError('force_id') },
        neighbourhoodHasErrors: function () { return this.hasError('neighbourhood_id') },
        retailerTypeHasErrors: function () { return this.hasError('retailer_type_id') },
        retailerNameHasErrors: function () { return this.hasError('retailer_name') },
        retailerStreetHasErrors: function () { return this.hasError('retailer_street') },
        retailerTownHasErrors: function () { return this.hasError('retailer_town') },
        retailerCountyHasErrors: function () { return this.hasError('retailer_county') },
        retailerPostcodeHasErrors: function () { return this.hasError('retailer_postcode') },
        retailerEmailHasErrors: function () { return this.hasError('retailer_email') },
        mondayOpenHasErrors: function () { return this.hasError('monday_open') },
        mondayCloseHasErrors: function () { return this.hasError('monday_close') },
        tuesdayOpenHasErrors: function () { return this.hasError('tuesday_open') },
        tuesdayCloseHasErrors: function () { return this.hasError('tuesday_close') },
        wednesdayOpenHasErrors: function () { return this.hasError('wednesday_open') },
        wednesdayCloseHasErrors: function () { return this.hasError('wednesday_close') },
        thursdayOpenHasErrors: function () { return this.hasError('thursday_open') },
        thursdayCloseHasErrors: function () { return this.hasError('thursday_close') },
        fridayOpenHasErrors: function () { return this.hasError('friday_open') },
        fridayCloseHasErrors: function () { return this.hasError('friday_close') },
        saturdayOpenHasErrors: function () { return this.hasError('saturday_open') },
        saturdayCloseHasErrors: function () { return this.hasError('saturday_close') },
        sundayOpenHasErrors: function () { return this.hasError('sunday_open') },
        sundayCloseHasErrors: function () { return this.hasError('sunday_close') },
        vrmHasErrors: function () { return this.hasError('mobile_vrm') },
    
        types: function () {
            return this.$store.state.retailertypes.data;
        },
        forces: function () {
            return this.$store.state.forces.data;
        },
        lpas: function () {
            if (this.force === '') {
                return [];
            }

            return this.$store.state.lpas.data.filter(lpa => lpa.force_id === this.force);  
        },
        neighbourhoods: function () {
            if (this.lpa === '') {
                return [];
            }

            return this.$store.state.neighbourhoods.data.filter(neighbourhood => neighbourhood.lpa_id == this.lpa);
        },
        categoryOptions: function () {
            return this.$store.state.productcategories.data;
        },
        risks: function () {
            return this.$store.state.risks.data.filter(risk => risk.retailer_type_id === this.retailerType);
        },
        selectedCategories: function () {
            var selectedCategories = [];

            this.categories.forEach((category) => {
                selectedCategories.push(category.id);
            });

            return selectedCategories;
        }
    }
}
</script>